import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import _ from 'lodash'
import Cookies from 'js-cookie'

import common from './modules/common'
import confirmOrder from './modules/confirmOrder'
import commodity from './modules/commodity'
import published from './modules/published'

const isPc = () => {
  if (+document.body.offsetWidth === 800 || document.body.offsetWidth > 1000) return true
  return false
}

const isShowAdvertis = true
Vue.prototype.$showAdvertis = isShowAdvertis

const state = {
  isPC: isPc(), // 当前设备是不是PC端
  menuCollapse: false, // 左侧菜单状态（展开，折叠），默认是展开
  language: 'en',
  isShowAdvertis, // 商城顶部是否展示广告
  website: ['https://kakaclo.com', 'https://www.kakaclo.com', 'https://mall.kakaclo.com', 'http://10.0.0.102', 'https://kakatest.com', 'http://kkpre.cn', 'http://mall.kkpre.cn']
}

const resetState = {
  ...state,
  common: _.cloneDeep(common.state),
  confirmOrder: _.cloneDeep(confirmOrder.state),
  commodity: _.cloneDeep(commodity.state),
  published: _.cloneDeep(published.state)
}

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations: {
    set(state, object) {
      Object.assign(state, object)
    },
    setState(state, object) {
      state[object.key] = object.value
    },
    setShowAdvertis(state, type) {
      state.isShowAdvertis = type
    }
  },
  actions: {
    // 重置所有state
    resetState({ state }) {
      localStorage.removeItem('vuex')
      localStorage.removeItem('similar_imglist')
      Object.assign(state, resetState)

      Cookies.remove('token', { path: '/', domain: `${process.env.VUE_APP_DOMAIN}` })
      Cookies.remove('userId', { path: '/', domain: `${process.env.VUE_APP_DOMAIN}` })
      Cookies.remove('userName', { path: '/', domain: `${process.env.VUE_APP_DOMAIN}` })
      Cookies.remove('email', { path: '/', domain: `${process.env.VUE_APP_DOMAIN}` })
      Cookies.remove('phone', { path: '/', domain: `${process.env.VUE_APP_DOMAIN}` })
      Cookies.remove('jti', { path: '/', domain: `${process.env.VUE_APP_DOMAIN}` })
      Cookies.remove('authorities', { path: '/', domain: `${process.env.VUE_APP_DOMAIN}` })

      localStorage.setItem('reset_login_state', !JSON.parse(localStorage.getItem('reset_login_state')))
    },
    // 退出登录
    logOut({ dispatch }, param) {
      dispatch('resetState')
      if (window.location.search.includes('seo=logout')) {
        localStorage.removeItem('loginRedirection')
        return
      }
      if (param && param.noJump) return
      location.href = '/login'
    },
    // 版本更新机制  指定需清除的缓存
    resetAssignState({ commit, state }) {
      // 清除品类列表
      commit('common/set', {
        categoryTree: []
      })
    }
  },
  modules: {
    confirmOrder,
    common,
    published,
    commodity
  },
  plugins: [createPersistedState({
    storage: window.localStorage,
    filter: (mutation) => {
      return !mutation.type.includes('setShowAdvertis')
    }
  })]
})
